module.exports = __webpack_public_path__ + "img/mine_w.629da6a8.svg";